import { useContext } from "react"

import SelectContext from "./SelectContext"

type Props = JSX.IntrinsicElements["option"]

const Option = ({ value, ...props }: Props) => {
  const { shouldRender = () => true } = useContext(SelectContext)

  if (!shouldRender(value?.toString())) {
    return null
  }

  return <option {...props} value={value} />
}

export default Option
